import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import matchSorter from 'match-sorter'
import { thousandSeparator } from '../../utils/Utils'
import { CiclePlus, CicleMinus, Rub } from '../app-icon/Icons'
import cx from 'classnames'

// Import React Table
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import './m-table.css'

const styles = theme => ({
  tableWrapper: {
    maxWidth: '100%',
    margin: '5px 10px 20px 10px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    overflow: 'hidden',
    paddingBottom: 16,
  },
  tableTitle: {
    fontSize: '14px',
    textAlign: 'center',
    padding: '15px 0',
  },
  subTable: {},
  subTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  dislike: {
    transform: 'rotate(180deg)',
  },
  chanelInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  chanelInfoItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 20px',
    fontSize: 12,
  },
})

class MTable extends Component {
  state = {
    data: this.props.data,
    summaryData: this.props.summaryData,
    defaultPageSize: this.props.data.length,
    resized: [],
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: this.props.data,
        defaultPageSize: this.props.data.length,
      })
    }

    if (prevProps.summaryData !== this.props.summaryData) {
      this.setState({
        summaryData: this.props.summaryData,
      })
    }
  }

  _handleResizeChange = resized => {
    this.setState({ resized })
  }

  _renderSubComponent = props => (
    <NestedTable
      {...props}
      resized={this.state.resized}
      parentState={this.state}
      parentProps={this.props}
      demo={this.props.demo}
    />
  )

  render() {
    const { classes, demo } = this.props
    const { data, summaryData } = this.state

    return (
      <div className={classes.tableWrapper}>
        <div className={classes.tableTitle}>Отчет по источникам трафика</div>
        {demo && (
          <div className={classes.chanelInfo}>
            <div className={classes.chanelInfoItem}>
              <span className="chanelInfoItem_good"></span>
              <span> - эффективный канал</span>
            </div>
            <div className={classes.chanelInfoItem}>
              <span className="chanelInfoItem_bad"></span>
              <span> - неэффективный канал</span>
            </div>
          </div>
        )}

        <React.Fragment>
          <ReactTable
            data={data}
            pageSize={this.props.data.length}
            showPagination={false}
            resizable={true}
            onResizedChange={this._handleResizeChange}
            SubComponent={this._renderSubComponent}
            columns={[
              {
                Header: '',
                expander: true,
                width: 26,
                filterable: false,
                sortable: false,
                resizable: false,
                Expander: ({ isExpanded, ...rest }) => (
                  <div className="mainRow">
                    {isExpanded ? (
                      <div className="circle">
                        <CicleMinus width={16} height={16} fill={'#8866ff'} />
                      </div>
                    ) : (
                      <div className="circle">
                        <CiclePlus width={16} height={16} fill={'#8866ff'} />
                      </div>
                    )}
                  </div>
                ),
              },
              {
                Header: 'Источник',
                fixed: 'left',
                id: 'source',
                resizable: false,
                accessor: d => d.source,
                width: 500,
                resizable: false,
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['source'] }),
                filterAll: true,
                Cell: row => {
                  return (
                    <div className={classes.subTitle}>
                      <div className="source-title">
                        {`${row.original.source} / ${row.original.medium}`}
                      </div>
                    </div>
                  )
                },
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      justifyContent: 'flex-start',
                    },
                  }
                },
                style: {
                  willChange: 'transform',
                },
                Footer: () => <div>Общий итог</div>,
              },
              {
                Header: 'Сеансы',
                id: 'sessions',
                accessor: d => Number(d.sessions),
                width: 100,
                Cell: ({ value }) => {
                  return `${thousandSeparator(value)}`
                },
                filterable: false,
                Footer: () => (
                  <div>{thousandSeparator(summaryData.sessions)}</div>
                ),
              },
              {
                Header: `Конверсия\n в заявку`,
                id: 'leadsConversion',
                filterable: false,
                minWidth: 50,
                accessor: d => Number(d.leadsConversion),
                Cell: ({ value }) => {
                  return `${thousandSeparator(Number(value).toFixed(2))} %`
                },
                Footer: () => (
                  <div>
                    {thousandSeparator(summaryData.leadsConversion.toFixed(2))}{' '}
                    %
                  </div>
                ),
              },
              {
                Header: 'Заявки',
                id: 'leads',
                minWidth: 50,
                filterable: false,
                accessor: d => Number(d.leads),
                Cell: ({ value }) => {
                  return `${thousandSeparator(value)}`
                },
                Footer: () => <div>{thousandSeparator(summaryData.leads)}</div>,
              },
              {
                Header: `Конверсия\n в продажу`,
                id: 'ordersConversion',
                filterable: false,
                minWidth: 50,
                accessor: d => Number(d.ordersConversion),
                Cell: ({ value }) => {
                  return `${thousandSeparator(value.toFixed(2))} %`
                },
                Footer: () => (
                  <div>
                    {thousandSeparator(summaryData.ordersConversion.toFixed(2))}{' '}
                    %
                  </div>
                ),
              },
              {
                Header: 'Продажи',
                id: 'orders',
                filterable: false,
                minWidth: 50,
                accessor: d => Number(d.orders),
                Cell: ({ value }) => {
                  return `${thousandSeparator(value)}`
                },
                Footer: () => (
                  <div>{thousandSeparator(summaryData.orders)}</div>
                ),
              },
              {
                Header: 'Выручка',
                id: 'revenue',
                filterable: false,
                minWidth: 50,
                accessor: d => Number(d.revenue).toFixed(2),
                Cell: ({ value }) => {
                  return (
                    <span>
                      {`${thousandSeparator(Number(value).toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  )
                },
                Footer: () => (
                  <div>
                    {thousandSeparator(summaryData.revenue.toFixed(2))}
                    <Rub width={8} height={8} className="rub" />
                  </div>
                ),
              },
              {
                Header: 'Расходы\n на рекламу',
                id: 'cost',
                filterable: false,
                minWidth: 50,
                accessor: d => Number(d.cost),
                Cell: ({ value }) => {
                  return (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  )
                },
                Footer: () => (
                  <div>
                    {thousandSeparator(summaryData.cost.toFixed(2))}
                    <Rub width={8} height={8} className="rub" />
                  </div>
                ),
              },
              {
                Header: 'CPC',
                id: 'cpc',
                filterable: false,
                minWidth: 50,
                accessor: d => Number(d.cpc),
                Cell: ({ value }) => {
                  return (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  )
                },
                Footer: () => (
                  <div>
                    {thousandSeparator(summaryData.cpc.toFixed(2))}
                    <Rub width={8} height={8} className="rub" />
                  </div>
                ),
              },
              {
                Header: 'CPA',
                id: 'cpa',
                filterable: false,
                minWidth: 50,
                accessor: d => Number(d.cpa),
                Cell: ({ value }) => {
                  return (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  )
                },
                Footer: () => (
                  <div>
                    {thousandSeparator(summaryData.cpa.toFixed(2))}
                    <Rub width={8} height={8} className="rub" />
                  </div>
                ),
              },
              {
                Header: 'CPO',
                id: 'cpo',
                filterable: false,
                minWidth: 50,
                accessor: d => Number(d.cpo),
                Cell: ({ value }) => {
                  return (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  )
                },
                Footer: () => (
                  <div>
                    {thousandSeparator(summaryData.cpo.toFixed(2))}
                    <Rub width={8} height={8} className="rub" />
                  </div>
                ),
              },
              {
                Header: 'ROMI',
                id: 'romi',
                filterable: false,
                minWidth: 50,
                accessor: d => Number(d.romi),
                Cell: ({ value }) => {
                  return `${thousandSeparator(value.toFixed(2))} %`
                },
                Footer: () => (
                  <div>{thousandSeparator(summaryData.romi.toFixed(2))} %</div>
                ),
              },
            ]}
            defaultSorted={[
              {
                id: 'cost',
                desc: true,
              },
            ]}
            filterable
            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value
            }
            getTrProps={(state, rowInfo, instance) => {
              if (rowInfo && demo) {
                const { cost, leads, orders, cpa, cpo } = rowInfo.original
                return {
                  className: cx('any', {
                    good:
                      (cost && leads && orders) > 0 && cpa < 500 && cpo < 1000,
                    bad:
                      cost > 0 &&
                      leads <= 0 &&
                      orders <= 0 &&
                      cpa > 500 &&
                      cpo > 1000,
                  }),
                }
              } else {
                return {
                  className: 'any',
                }
              }
            }}
            noDataText="Нет данных"
            style={{ height: 522 }}
            className="-striped -highlight"
          />
        </React.Fragment>
      </div>
    )
  }
}

class NestedTable extends Component {
  render() {
    const { campaigns } = this.props.original
    const { resized, demo } = this.props

    return (
      <ReactTable
        data={campaigns}
        pageSize={campaigns.length}
        showPagination={false}
        resized={resized}
        columns={[
          {
            width: 26,
            filterable: false,
            sortable: false,
            resizable: false,
          },
          {
            Header: '',
            expander: true,
            width: 500,
            filterAll: false,
            resizable: false,
            className: 'firstLevel',
            Expander: ({ isExpanded, ...rest }) => {
              if (
                rest.original.terms == null ||
                rest.original.terms.length == 0
              ) {
                return (
                  <div className="subRow">
                    <div
                      className="tablePoint"
                      style={{ cursorPointer: 'none' }}
                    ></div>
                    <div className="source-title">{rest.original.campaign}</div>
                  </div>
                )
              }
              return (
                <div className="subRow">
                  <div className="table-toggle">
                    {isExpanded ? (
                      <div className="circle">
                        <CicleMinus width={16} height={16} fill={'#8866ff'} />
                      </div>
                    ) : (
                      <div className="circle">
                        <CiclePlus width={16} height={16} fill={'#8866ff'} />
                      </div>
                    )}
                  </div>
                  <div className="source-title">{rest.original.campaign}</div>
                </div>
              )
            },
            getProps: (state, rowInfo, column) => {
              if (rowInfo) {
                if (
                  rowInfo.original.terms == null ||
                  rowInfo.original.terms.length == 0
                ) {
                  return {
                    onClick: () => {},
                  }
                }
              }
              return {
                style: {
                  padding: 0,
                },
              }
            },
          },
          {
            Header: '',
            id: 'sessions',
            accessor: d => Number(d.sessions),
            width: 100,
            Cell: ({ value }) => {
              return `${thousandSeparator(value)}`
            },
            filterable: false,
          },
          {
            Header: '',
            id: 'leadsConversion',
            filterable: false,
            minWidth: 50,
            accessor: d => Number(d.leadsConversion),
            Cell: ({ value }) => {
              return `${thousandSeparator(Number(value).toFixed(2))} %`
            },
          },
          {
            Header: '',
            id: 'leads',
            minWidth: 50,
            filterable: false,
            accessor: d => Number(d.leads),
            Cell: ({ value }) => {
              return `${thousandSeparator(value)}`
            },
          },
          {
            Header: '',
            id: 'ordersConversion',
            filterable: false,
            minWidth: 50,
            accessor: d => Number(d.ordersConversion),
            Cell: ({ value }) => {
              return `${thousandSeparator(value.toFixed(2))} %`
            },
          },
          {
            Header: '',
            id: 'orders',
            filterable: false,
            minWidth: 50,
            accessor: d => Number(d.orders),
            Cell: ({ value }) => {
              return `${thousandSeparator(value)}`
            },
          },
          {
            Header: '',
            id: 'revenue',
            filterable: false,
            minWidth: 50,
            accessor: d => Number(d.revenue).toFixed(2),
            Cell: ({ value }) => {
              return (
                <span>
                  {`${thousandSeparator(Number(value).toFixed(2))}`}{' '}
                  <Rub width={8} height={8} className="rub" />
                </span>
              )
            },
          },
          {
            Header: '',
            id: 'cost',
            filterable: false,
            minWidth: 50,
            accessor: d => Number(d.cost),
            Cell: ({ value }) => {
              return (
                <span>
                  {`${thousandSeparator(value.toFixed(2))}`}{' '}
                  <Rub width={8} height={8} className="rub" />
                </span>
              )
            },
          },
          {
            Header: '',
            id: 'cpc',
            filterable: false,
            minWidth: 50,
            accessor: d => Number(d.cpc),
            Cell: ({ value }) => {
              return (
                <span>
                  {`${thousandSeparator(value.toFixed(2))}`}{' '}
                  <Rub width={8} height={8} className="rub" />
                </span>
              )
            },
          },
          {
            Header: '',
            id: 'cpa',
            filterable: false,
            minWidth: 50,
            accessor: d => Number(d.cpa),
            Cell: ({ value }) => {
              return (
                <span>
                  {`${thousandSeparator(value.toFixed(2))}`}{' '}
                  <Rub width={8} height={8} className="rub" />
                </span>
              )
            },
          },
          {
            Header: '',
            id: 'cpo',
            filterable: false,
            minWidth: 50,
            accessor: d => Number(d.cpo),
            Cell: ({ value }) => {
              return (
                <span>
                  {`${thousandSeparator(value.toFixed(2))}`}{' '}
                  <Rub width={8} height={8} className="rub" />
                </span>
              )
            },
          },
          {
            Header: '',
            id: 'romi',
            filterable: false,
            minWidth: 50,
            accessor: d => Number(d.romi),
            Cell: ({ value }) => {
              return `${thousandSeparator(value.toFixed(2))} %`
            },
          },
        ]}
        getTrProps={(state, rowInfo, instance) => {
          if (rowInfo && demo) {
            const { cost, leads, orders, cpa, cpo } = rowInfo.original
            return {
              className: cx({
                good: (cost && leads && orders) > 0 && cpa < 500 && cpo < 1000,
                bad:
                  cost > 0 &&
                  leads <= 0 &&
                  orders <= 0 &&
                  cpa > 500 &&
                  cpo > 1000,
              }),
            }
          } else {
            return {
              className: 'any',
            }
          }
        }}
        SubComponent={row => {
          const { terms } = row.original
          return (
            <ReactTable
              data={terms}
              pageSize={terms.length}
              showPagination={false}
              resized={resized}
              columns={[
                {
                  width: 26,
                  Header: '',
                  resizable: false,
                },
                {
                  Header: '',
                  expander: true,
                  width: 500,
                  filterAll: false,
                  resizable: false,
                  className: 'secondLevel',
                  Expander: ({ isExpanded, ...rest }) => {
                    if (
                      rest.original.content == null ||
                      rest.original.content.length == 0
                    ) {
                      return (
                        <div className="subRow">
                          <div
                            className="tablePoint"
                            style={{ cursorPointer: 'none' }}
                          ></div>
                          <div className="source-title">
                            {rest.original.term}
                          </div>
                        </div>
                      )
                    }
                    return (
                      <div className="subRow">
                        <div className="table-toggle">
                          {isExpanded ? (
                            <div className="circle">
                              <CicleMinus
                                width={16}
                                height={16}
                                fill={'#8866ff'}
                              />
                            </div>
                          ) : (
                            <div className="circle">
                              <CiclePlus
                                width={16}
                                height={16}
                                fill={'#8866ff'}
                              />
                            </div>
                          )}
                        </div>
                        <div className="source-title">{rest.original.term}</div>
                      </div>
                    )
                  },
                  getProps: (state, rowInfo, column) => {
                    if (rowInfo) {
                      if (
                        rowInfo.original.content == null ||
                        rowInfo.original.content.length == 0
                      ) {
                        return {
                          onClick: () => {},
                        }
                      }
                    }
                    return {
                      style: {
                        padding: 0,
                      },
                    }
                  },
                },
                {
                  Header: '',
                  id: 'sessions',
                  accessor: d => Number(d.sessions),
                  width: 100,
                  Cell: ({ value }) => {
                    return `${thousandSeparator(value)}`
                  },
                  filterable: false,
                },
                {
                  Header: '',
                  id: 'leadsConversion',
                  filterable: false,
                  minWidth: 50,
                  accessor: d => Number(d.leadsConversion),
                  Cell: ({ value }) => {
                    return `${thousandSeparator(Number(value).toFixed(2))} %`
                  },
                },
                {
                  Header: '',
                  id: 'leads',
                  minWidth: 50,
                  filterable: false,
                  accessor: d => Number(d.leads),
                  Cell: ({ value }) => {
                    return `${thousandSeparator(value)}`
                  },
                },
                {
                  Header: '',
                  id: 'ordersConversion',
                  filterable: false,
                  minWidth: 50,
                  accessor: d => Number(d.ordersConversion),
                  Cell: ({ value }) => {
                    return `${thousandSeparator(value.toFixed(2))} %`
                  },
                },
                {
                  Header: '',
                  id: 'orders',
                  filterable: false,
                  minWidth: 50,
                  accessor: d => Number(d.orders),
                  Cell: ({ value }) => {
                    return `${thousandSeparator(value)}`
                  },
                },
                {
                  Header: '',
                  id: 'revenue',
                  filterable: false,
                  minWidth: 50,
                  accessor: d => Number(d.revenue).toFixed(2),
                  Cell: ({ value }) => {
                    return (
                      <span>
                        {`${thousandSeparator(Number(value).toFixed(2))}`}{' '}
                        <Rub width={8} height={8} className="rub" />
                      </span>
                    )
                  },
                },
                {
                  Header: '',
                  id: 'cost',
                  filterable: false,
                  minWidth: 50,
                  accessor: d => Number(d.cost),
                  Cell: ({ value }) => {
                    return (
                      <span>
                        {`${thousandSeparator(value.toFixed(2))}`}{' '}
                        <Rub width={8} height={8} className="rub" />
                      </span>
                    )
                  },
                },
                {
                  Header: '',
                  id: 'cpc',
                  filterable: false,
                  minWidth: 50,
                  accessor: d => Number(d.cpc),
                  Cell: ({ value }) => {
                    return (
                      <span>
                        {`${thousandSeparator(value.toFixed(2))}`}{' '}
                        <Rub width={8} height={8} className="rub" />
                      </span>
                    )
                  },
                },
                {
                  Header: '',
                  id: 'cpa',
                  filterable: false,
                  minWidth: 50,
                  accessor: d => Number(d.cpa),
                  Cell: ({ value }) => {
                    return (
                      <span>
                        {`${thousandSeparator(value.toFixed(2))}`}{' '}
                        <Rub width={8} height={8} className="rub" />
                      </span>
                    )
                  },
                },
                {
                  Header: '',
                  id: 'cpo',
                  filterable: false,
                  minWidth: 50,
                  accessor: d => Number(d.cpo),
                  Cell: ({ value }) => {
                    return (
                      <span>
                        {`${thousandSeparator(value.toFixed(2))}`}{' '}
                        <Rub width={8} height={8} className="rub" />
                      </span>
                    )
                  },
                },
                {
                  Header: '',
                  id: 'romi',
                  filterable: false,
                  minWidth: 50,
                  accessor: d => Number(d.romi),
                  Cell: ({ value }) => {
                    return `${thousandSeparator(value.toFixed(2))} %`
                  },
                },
              ]}
              SubComponent={row => {
                const { content } = row.original
                return (
                  <ReactTable
                    data={content}
                    pageSize={content.length}
                    showPagination={false}
                    resized={resized}
                    columns={[
                      {
                        Header: '',
                        width: 26,
                        resizable: false,
                      },
                      {
                        Header: '',
                        id: 'source',
                        resizable: false,
                        accessor: d => d.source,
                        width: 500,
                        filterAll: false,
                        Cell: row => {
                          return (
                            <div className="subRow">
                              <div className="tablePoint"></div>
                              <div className="content-title">
                                {`${row.original.content}`}
                              </div>
                            </div>
                          )
                        },
                        getProps: (state, rowInfo, column) => {
                          return {
                            className: 'thirdLevel',
                          }
                        },
                      },
                      {
                        Header: '',
                        id: 'sessions',
                        accessor: d => Number(d.sessions),
                        width: 100,
                        Cell: ({ value }) => {
                          return `${thousandSeparator(value)}`
                        },
                        filterable: false,
                      },
                      {
                        Header: '',
                        id: 'leadsConversion',
                        filterable: false,
                        minWidth: 50,
                        accessor: d => Number(d.leadsConversion),
                        Cell: ({ value }) => {
                          return `${thousandSeparator(
                            Number(value).toFixed(2)
                          )} %`
                        },
                      },
                      {
                        Header: '',
                        id: 'leads',
                        minWidth: 50,
                        filterable: false,
                        accessor: d => Number(d.leads),
                        Cell: ({ value }) => {
                          return `${thousandSeparator(value)}`
                        },
                      },
                      {
                        Header: '',
                        id: 'ordersConversion',
                        filterable: false,
                        minWidth: 50,
                        accessor: d => Number(d.ordersConversion),
                        Cell: ({ value }) => {
                          return `${thousandSeparator(value.toFixed(2))} %`
                        },
                      },
                      {
                        Header: '',
                        id: 'orders',
                        filterable: false,
                        minWidth: 50,
                        accessor: d => Number(d.orders),
                        Cell: ({ value }) => {
                          return `${thousandSeparator(value)}`
                        },
                      },
                      {
                        Header: '',
                        id: 'revenue',
                        filterable: false,
                        minWidth: 50,
                        accessor: d => Number(d.revenue).toFixed(2),
                        Cell: ({ value }) => {
                          return `${thousandSeparator(
                            Number(value).toFixed(2)
                          )} ₽`
                        },
                      },
                      {
                        Header: '',
                        id: 'cost',
                        filterable: false,
                        minWidth: 50,
                        accessor: d => Number(d.cost),
                        Cell: ({ value }) => {
                          return (
                            <span>
                              {`${thousandSeparator(value.toFixed(2))}`}{' '}
                              <Rub width={8} height={8} className="rub" />
                            </span>
                          )
                        },
                      },
                      {
                        Header: '',
                        id: 'cpc',
                        filterable: false,
                        minWidth: 50,
                        accessor: d => Number(d.cpc),
                        Cell: ({ value }) => {
                          return (
                            <span>
                              {`${thousandSeparator(value.toFixed(2))}`}{' '}
                              <Rub width={8} height={8} className="rub" />
                            </span>
                          )
                        },
                      },
                      {
                        Header: '',
                        id: 'cpa',
                        filterable: false,
                        minWidth: 50,
                        accessor: d => Number(d.cpa),
                        Cell: ({ value }) => {
                          return (
                            <span>
                              {`${thousandSeparator(value.toFixed(2))}`}{' '}
                              <Rub width={8} height={8} className="rub" />
                            </span>
                          )
                        },
                      },
                      {
                        Header: '',
                        id: 'cpo',
                        filterable: false,
                        minWidth: 50,
                        accessor: d => Number(d.cpo),
                        Cell: ({ value }) => {
                          return (
                            <span>
                              {`${thousandSeparator(value.toFixed(2))}`}{' '}
                              <Rub width={8} height={8} className="rub" />
                            </span>
                          )
                        },
                      },
                      {
                        Header: '',
                        id: 'romi',
                        filterable: false,
                        resizable: false,
                        minWidth: 50,
                        accessor: d => Number(d.romi),
                        Cell: ({ value }) => {
                          return `${thousandSeparator(value.toFixed(2))} %`
                        },
                      },
                    ]}
                  />
                )
              }}
            />
          )
        }}
        className="subTable"
      />
    )
  }
}

export default withStyles(styles)(MTable)
